import { memo, useRef } from 'react';

import { type Row } from '@tanstack/react-table';

import { DraggableDataTable, NoDataMessage } from '@/_containers';

import { type TableViewProps, useTableView } from './use-table-view';

import type { PickTicketsItemCreateSchema } from '../schema';

function TableViewBase(props: TableViewProps) {
  const ref = useRef(false);
  const { cacheBuster, tableData, isEditable, table, handleDragEnd } = useTableView(props);

  ref.current = !ref.current;

  const rowCallback = (_row: Row<PickTicketsItemCreateSchema>) => {
    return '';
  };

  if (tableData.length < 1) {
    return <NoDataMessage message="No inventory kit items found" className="mt-8" />;
  }

  return (
    <>
      <div
        className="mt-4"
        data-key={`ed-${tableData.length}-${cacheBuster}`}
        key={isEditable ? `ed-${tableData.length}-${cacheBuster}-${ref.current}` : 'non-editable'}
      >
        <DraggableDataTable rowCallback={rowCallback} table={table} handleDragEnd={handleDragEnd} />
      </div>
    </>
  );
}

export const TableView = memo(TableViewBase);
